import React from 'react';
import { Ship } from 'lucide-react';
import { UserMenu } from '../auth/UserMenu';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-[var(--primary-bg)]">
      <header className="h-14 border-b border-[var(--border-color)] px-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Ship className="w-6 h-6 text-[var(--accent-color)]" />
          <h1 className="text-lg font-semibold">Catamaran Weather Explorer</h1>
        </div>
        <UserMenu />
      </header>
      <main className="flex h-[calc(100vh-3.5rem)]">
        {children}
      </main>
    </div>
  );
}